import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CameraIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(2.000000, 6.000000)">
          <path
            d="M42.415,8.279 L37.749,8.279 L33.69,1.101 C33.306,0.421 32.585,0 31.804,0 L23.547,0 C22.729,0 21.986,0.475 21.641,1.217 L18.362,8.279 L3.254,8.279 C1.457,8.279 0,9.736 0,11.532 L0,34.816 C0,36.613 1.457,38.07 3.254,38.07 L42.415,38.07 C44.212,38.07 45.669,36.613 45.669,34.816 L45.669,11.532 C45.669,9.736 44.212,8.279 42.415,8.279"
            fill="#ffffff"
            className={styles.white}
          ></path>
          <path
            d="M42.415,8.279 L37.749,8.279 L33.69,1.101 C33.306,0.421 32.585,0 31.804,0 L23.547,0 C22.729,0 21.986,0.475 21.641,1.217 L18.362,8.279 L3.254,8.279 C1.457,8.279 0,9.736 0,11.532 L0,34.816 C0,36.613 1.457,38.07 3.254,38.07 L42.415,38.07 C44.212,38.07 45.669,36.613 45.669,34.816 L45.669,11.532 C45.669,9.736 44.212,8.279 42.415,8.279 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeWidth="2"
          ></path>
          <g transform="translate(5.109700, 4.251100)">
            <path
              d="M9.115,3.209 L9.115,2.024 C9.115,1.477 8.672,1.034 8.125,1.034 L8.043,1.034 L8.043,0.721 C8.043,0.323 7.72,0 7.321,0 L2.1,0 C1.702,0 1.379,0.323 1.379,0.721 L1.379,1.034 L0.99,1.034 C0.443,1.034 0,1.477 0,2.024 L0,3.065"
              fill="#ffffff"
              className={styles.white}
            ></path>
            <path
              d="M9.115,3.209 L9.115,2.024 C9.115,1.477 8.672,1.034 8.125,1.034 L8.043,1.034 L8.043,0.721 C8.043,0.323 7.72,0 7.321,0 L2.1,0 C1.702,0 1.379,0.323 1.379,0.721 L1.379,1.034 L0.99,1.034 C0.443,1.034 0,1.477 0,2.024 L0,3.065"
              stroke="#000000"
              className={styles.defaultStrokeColor}
              strokeWidth="2"
            ></path>
          </g>
          <path
            d="M39.8249,22.8101 C39.8249,29.3671 34.5099,34.6821 27.9529,34.6821 C21.3969,34.6821 16.0819,29.3671 16.0819,22.8101 C16.0819,16.2531 21.3969,10.9381 27.9529,10.9381 C34.5099,10.9381 39.8249,16.2531 39.8249,22.8101 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M37.2022,22.7658 C37.2022,27.9138 33.0292,32.0858 27.8822,32.0858 C22.7342,32.0858 18.5612,27.9138 18.5612,22.7658 C18.5612,17.6178 22.7342,13.4458 27.8822,13.4458 C33.0292,13.4458 37.2022,17.6178 37.2022,22.7658 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M15.6813,14.104 C15.6813,15.485 14.5623,16.604 13.1813,16.604 C11.8003,16.604 10.6813,15.485 10.6813,14.104 C10.6813,12.723 11.8003,11.604 13.1813,11.604 C14.5623,11.604 15.6813,12.723 15.6813,14.104"
            fill="#0050B3"
            className={styles.interactiveColor}
          ></path>
          <path
            d="M30.3709,6.4338 L25.8239,6.4338 C25.4759,6.4338 25.1949,6.1518 25.1949,5.8048 L25.1949,4.0388 C25.1949,3.6908 25.4759,3.4098 25.8239,3.4098 L30.3709,3.4098 C30.7179,3.4098 30.9999,3.6908 30.9999,4.0388 L30.9999,5.8048 C30.9999,6.1518 30.7179,6.4338 30.3709,6.4338 Z"
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <line
            stroke="#000000"
            className={styles.defaultStrokeColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            x1="5.1096"
            x2="5.1096"
            y1="14.1062"
            y2="31.4022"
          ></line>
        </g>
      </g>
    </Icon>
  )
}
